import { countryCodeSchema } from '@buggy/shared'
import { FunctionComponent, useState } from 'react'
import { useAnalyzeRankingQuery } from '@/api/k6/analyze-api'
import { RankType } from '@/api/workspaces-api'
import Content from '@/components/billboard/top100/content'
import Header from '@/components/billboard/top100/header'
import Sorter from '@/components/billboard/top100/sorter'
import { RankingPlatformType } from '@/types/schema/k6/analyze-api'

interface BoardProps {
  platform: RankingPlatformType
  rankType:
    | RankType.ViewRate
    | RankType.WordOfMouthVolume
    | RankType.EngagementRate
  title: string
  description: string
  aboutList: string[]
}

const Top100Page: FunctionComponent<BoardProps> = ({
  platform,
  rankType,
  title,
  description,
  aboutList,
}) => {
  const [hasKolBusinessType, setHasKolBusinessType] = useState(true)
  const { data: response } = useAnalyzeRankingQuery({
    platform: platform,
    countryCode: countryCodeSchema.enum.tw, //top 100 only support tw
    kolBusinessType: hasKolBusinessType,
    rankType: rankType,
  })

  const { lastUpdatedAt = null, data: items = [] } = response ?? {}

  return (
    <>
      <Header description={description} platform={platform} title={title} />
      <Sorter
        hasKolBusinessType={hasKolBusinessType}
        rankType={rankType}
        onKolBusinessTypeChange={setHasKolBusinessType}
      />
      <Content
        aboutList={aboutList}
        analyzeRankingList={items}
        lastUpdatedAt={lastUpdatedAt}
        platform={platform}
        rankType={rankType}
      />
    </>
  )
}

export default Top100Page
